import { use } from 'react';

import { useTranslation } from 'react-i18next';

import { MultiPageDialog } from '~components';
import { StatusVariant } from '~enums';
import SelectedKeysContext from '~features/keys/providers/selectedKeysContext';

import SelectedKeysOverview from '../forms/selectedKeysOverview';

interface Props {
	open: boolean;
	loading: boolean;
	onClose: () => void;
	onFinish: () => void;
}

const KeyMultiUnassignDialog = ({ open, loading, onClose, onFinish }: Props) => {
	const { t } = useTranslation();
	const selectedKeysContext = use(SelectedKeysContext);

	const title =
		selectedKeysContext.singleKey ?
			t('key.labels.unassignKeyDialogTitle', { ns: 'entities' })
		:	t('key.labels.multiUnassignDialogTitle', { ns: 'entities' });

	return (
		<MultiPageDialog
			title={title}
			open={open}
			loading={loading}
			onClose={onClose}
			onFinish={onFinish}
			variant={StatusVariant.Destructive}
			pages={[
				{
					key: 'selectedKeys',
					content: (
						<SelectedKeysOverview
							selectedKeys={
								selectedKeysContext.singleKey ?
									[selectedKeysContext.singleKey]
								:	selectedKeysContext.selectedKeys
							}
							onRemoveClicked={selectedKeysContext.removeKey}
						/>
					),
				},
			]}
		/>
	);
};

export default KeyMultiUnassignDialog;
